import isArray from 'lodash/isArray';
import { Stack, Text } from '@etg/wings';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const TicketDetailsSection = _ref => {
  let {
    content,
    title
  } = _ref;
  const isList = isArray(content);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [title && /*#__PURE__*/_jsxs(Text, {
      "data-testid": "drawer-ticket-section-title",
      children: [title, ":"]
    }), isList && /*#__PURE__*/_jsx(Stack, {
      as: "ul",
      "data-testid": "drawer-ticket-section-list",
      role: "list",
      spacing: 8,
      children: content.length && content.map((list, index) => /*#__PURE__*/_jsx(Text, {
        as: "li",
        children: list
      }, index))
    }), !isList && /*#__PURE__*/_jsx(Text, {
      "data-testid": "drawer-ticket-section-plain-text",
      children: content
    })]
  });
};
export default TicketDetailsSection;
//# sourceMappingURL=TicketDetailsSection.js.map